import { useState } from "react";
import Helmet from "react-helmet";
import { useParams } from "react-router-dom";
import styled from "@emotion/styled";
import dayjs from "dayjs";
import {
  useGetPartyQuery,
  useGetMeQuery,
  useGetMyStatsQuery,
  useGetMyResultsLazyQuery,
  useGetGamesQuery,
} from "generated/graphql";
import SideBar from "components/sidebar/Sidebar";
import NavBar from "components/navbar/NavBar";

const StatsPageWrapper = styled.div`
  * {
    padding: 0;
    margin: 0;
    text-decoration: none;
    list-style: none;
    box-sizing: border-box;
  }

  span {
    color: #7d7d7d;
  }

  /* Side Navbar */

  .checkbtn {
    font-size: 30px;
    color: #ffffff;
    float: right;
    line-height: 80px;
    margin-right: 10px;
    /* margin-top: -40px; */
    cursor: pointer;
    display: none;
  }

  #check {
    display: none;
  }

  .sponsor {
    width: 100;
    height: 30px;
    margin-top: 20px;
    margin-left: -5px;
  }

  .sidebar {
    width: 200px;
    height: 100%;
    background: #701129;
    padding: 30px 0px;
    position: fixed;
  }

  .side-logo {
    width: 100px;
    height: 100px;
    margin-bottom: 30px;
    margin-left: 50px;
    margin-top: -20px;
  }

  .search {
    width: 170px;
    height: 35px;
    margin-left: 15px;
    margin-top: -20px;
    margin-bottom: 30px;
  }

  .sidebar ul {
    list-style-type: none;
    margin-top: 0px;
  }

  .sidebar ul li {
    padding: 15px;
  }

  .sidebar ul li a {
    color: #ffffff;
    display: block;
    text-decoration: none;
    font-weight: bold;
    text-align: center;
    margin-right: 15px;
  }

  /* Top Navbar */

  .header {
    /* background: #ffffff; */
  }

  .profilePic img {
    width: 30px;
    height: 30px;
    margin-right: 10px;
  }

  /* Profile Info */

  .profile_cover_photo {
    position: relative;
    width: 100%;
    margin-top: -20px;
  }

  .profile_page_pic img {
    position: absolute;
    top: 220px;
    left: 230px;
    width: 140px;
    height: 140px;
  }

  .container2 {
    display: block;
    padding-top: 80px;
    margin-left: 200px;
    height: 320px;
  }

  .profile_trophies {
    position: absolute;
    top: 290px;
    left: 20px;
    font-weight: bold;
    font-size: large;
    margin-left: 370px;
  }

  .username {
    font-size: 30px;
    font-weight: bolder;
  }

  .g_record {
    margin-left: 135px;
    margin-top: -55px;
  }

  .t_cash {
    margin-left: 135px;
  }

  .profile_trophies p {
    padding-top: 5px;
  }

  .profile_trophies img {
    width: 35px;
    height: 35px;
    margin-top: 10px;
  }

  /* My Games */

  .floating-menu {
    background: #1d2029;
    padding: 5px;
    width: 635px;
    z-index: 100;
    margin-left: 420px;
    margin-top: 170px;
    border-radius: 15px;
  }

  .floating-menu a:hover {
    background-color: #282c38;
  }

  .floating-menu a.active {
    background-color: #ccc;
  }

  .floating-menu button {
    background: none;
    border: 0;
    color: #ffffff;
    font-family: "Rajdhani", sans-serif;
    font-size: 1.125rem;
    outline: none;
    padding: 0;
    margin-right: 40px;
    margin-left: 15px;
  }

  /* Tiers */

  .tiers {
    margin-left: 650px;
    margin-top: 30px;
  }

  .tiers button {
    width: 10%;
    height: 40px;
    background: #701129;
    border: 2px solid #701129;
    color: white;
    font-size: 15px;
    border-radius: 5px;
    margin-right: 20px;
  }

  /* My Games Table */

  table {
    border-collapse: collapse;
    width: 60%;
    margin-left: 350px;
    margin-top: 30px;
    margin-bottom: 50px;
  }

  td,
  th {
    border: 1px solid #7d7d7d;
    text-align: left;
    padding: 8px;
  }

  th {
    color: #7d7d7d;
  }

  .exitBttn {
    background-color: #701129;
    color: #ffffff;
    border: #701129 0;
  }

  @media (max-width: 858px) {
    .profilePic {
      margin-right: 50px;
    }
    .sidebar {
      width: 0%;
      height: 0%;
    }
    .search {
      display: none;
    }
    .side-logo {
      width: 55px;
      height: 55px;
      margin-top: -25px;
      margin-left: 5px;
    }
    .checkbtn {
      display: block;
    }
    .sidebar ul {
      position: fixed;
      width: 100%;
      height: 100vh;
      background: #701129;
      top: 70px;
      top: -100%;
      text-align: center;
      transition: all 0.5s;
    }
    #check:checked ~ .sidebar ul {
      top: 70px;
    }
  }
`;

function StatsPage() {
  // @ts-ignore
  let { username } = useParams();
  const { data, loading } = useGetPartyQuery({
    variables: {
      username,
    },
  });
  const { data: me } = useGetMeQuery();
  const { data: myStats, loading: loadingMyStats } = useGetMyStatsQuery();
  const { data: games, loading: loadingGames } = useGetGamesQuery();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [activeSection, setActiveSection] = useState("");

  const [getMyResults, { loading: loadingMyResults, data: myResults }] =
    useGetMyResultsLazyQuery();

  if (loadingMyStats || loadingGames) {
    return <></>;
  }

  const gamesMap = games
    ? games?.games
        .map(({ id, name }) => ({ [name]: id }))
        .reduce((acc, val) => ({ ...acc, ...val }), {})
    : {};

  return (
    <StatsPageWrapper>
      <Helmet>
        {data && (
          <title>{data?.party[0].nickname}'s stats — Jiwe eSports</title>
        )}
      </Helmet>
      <SideBar nickname={me?.me?.nickname} isLoggedIn={!!me?.me?.nickname} />
      {!loading && data && (
        <NavBar nickname={me?.me?.nickname} name={me?.me?.name} />
      )}
      <div className="container2">
        <div className="profile_parent">
          <img
            className="profile_cover_photo"
            src="/images/Profile_cover_photo (1).png"
            alt=""
          />
          <div className="profile_page_pic">
            <img src="/images/Profile_pic_square.png" alt="" />
          </div>
        </div>
      </div>
      <div className="profile_trophies">
        <p className="username">
          {data?.party[0].nickname}{" "}
          {data?.party[0].name === me?.me?.name && <>({data?.party[0].name})</>}
        </p>
        {!loadingMyStats && myStats && (
          <>
            <p className="kda">
              <span>KDA: </span> {myStats?.myStats?.ranks?.global.kda}
            </p>
            <p className="wl_ratio">
              <span>W/L Ratio: </span>{" "}
              {myStats?.myStats?.ranks?.global.winLossRatio}
            </p>
            <p className="g_record">
              <span>Game Record: </span>{" "}
              {myStats?.myStats?.ranks?.global.matchesPlayed
                ? myStats?.myStats?.ranks?.global.wins /
                  myStats?.myStats?.ranks?.global.matchesPlayed
                : 0}
            </p>
          </>
        )}
        {/* <p className="t_cash">
          <span>Total Cash: </span> Ksh 8,500
        </p> */}
        {/* Trophies */}
        <p className="trophies">
          <img src="/images/Gold Trophie.png" alt="" />0 &nbsp;
          <img src="/images/Silver Trophie.png" alt="" />0 &nbsp;
          <img src="/images/Bronze Trophie.png" alt="" />0
        </p>
      </div>

      {/* <!-- My Games --> */}
      <nav className="floating-menu">
        {!loading &&
          data?.party[0] &&
          data?.party[0].partyDetails
            .filter(({ key }) => key === "preferred_games")
            .map(({ value }) => JSON.parse(value!))
            .reduce((acc, val) => [...acc, ...val], [])
            .map((value: string) => (
              <button
                className="w3-bar-item w3-button"
                onClick={() => {
                  setActiveSection(value);
                  getMyResults({
                    variables: {
                      // @ts-ignore
                      gameId: gamesMap[value],
                      participants: [data.party[0].id],
                    },
                  });
                }}
              >
                {value}
              </button>
            ))}
        <button onClick={undefined} id="plus">
          <i className="far fa-plus-square"></i>
        </button>
      </nav>

      {/* <div className="tiers">
        <button onClick={() => setActiveSection("tier1")}>Tier 1</button>
        <button onClick={() => setActiveSection("tier2")}>Tier 2</button>
      </div> */}

      {/* <!-- My Games Table --> */}

      {!loadingMyResults && myResults && (
        <table id="games_table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Matches Played</th>
              <th>Rank</th>
              <th>Points</th>
              <th>KDA</th>
              {/* <th>Cash Won</th> */}
            </tr>
          </thead>
          <tbody>
            {myResults.tournament_results.map((tr) => (
              <tr key={tr.id}>
                <td>
                  {dayjs(tr.match.match_time.split("T")[0]).format(
                    "ddd	D MMM, YYYY"
                  )}
                </td>
                <td>{tr.result.matchesPlayed[data?.party[0].id]}</td>
                <td>{tr.result.placing[data?.party[0].id]}</td>
                <td>{tr.result.points[data?.party[0].id]}</td>
                <td>{tr.result.kda[data?.party[0].id]}</td>
                {/* <td>{tr.result.cashWon[data?.party[0].id]}</td> */}
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </StatsPageWrapper>
  );
}

export default StatsPage;
